import React, {useState} from 'react';
import {PendingClaimPlaceDto} from '../../generated/models/PendingClaimPlaceDto';

type PendingClaimPlaceRowProps = React.FC<{
  place: PendingClaimPlaceDto;
  onApprove: () => void;
  onDecline: () => void;
}>;

const imageBoxStyle: React.CSSProperties = {
  width: '96px',
  height: '72px',
  flexShrink: 0,
  borderRadius: '8px',
  objectFit: 'cover',
  backgroundColor: '#2a2a2a',
};

const buttonBaseStyle: React.CSSProperties = {
  padding: '10px 20px',
  borderRadius: '8px',
  border: 'none',
  cursor: 'pointer',
  fontWeight: 'bold',
  fontSize: '1em',
  transition: 'all 0.2s ease',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
};

export const PendingClaimPlaceRow: PendingClaimPlaceRowProps = ({
  place,
  onApprove,
  onDecline,
}) => {
  const [hoveredButton, setHoveredButton] = useState<
    'approve' | 'decline' | null
  >(null);

  const photo = place.photos?.[0];

  const approveStyle: React.CSSProperties = {
    ...buttonBaseStyle,
    backgroundColor: hoveredButton === 'approve' ? '#e6ff33' : '#daff00',
    color: '#1a1a1a',
    transform: hoveredButton === 'approve' ? 'scale(1.05)' : 'scale(1)',
  };

  const declineStyle: React.CSSProperties = {
    ...buttonBaseStyle,
    backgroundColor: hoveredButton === 'decline' ? '#fecaca' : '#fee2e2',
    color: '#991b1b',
    transform: hoveredButton === 'decline' ? 'scale(1.05)' : 'scale(1)',
  };

  return (
    <div
      style={{
        display: 'flex',
        // The buttons wrap under the place on narrow screens.
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '20px',
        padding: '16px 0',
        borderTop: '1px solid #333',
      }}>
      {photo ? (
        <img src={photo} alt={place.name ?? 'Place'} style={imageBoxStyle} />
      ) : (
        <div
          style={{
            ...imageBoxStyle,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#666',
            fontSize: '0.7rem',
          }}>
          No photo
        </div>
      )}

      <div style={{flex: '1 1 160px', minWidth: 0}}>
        <h4 style={{color: '#fff', margin: 0, fontSize: '1.05rem'}}>
          {place.name || 'Unnamed place'}
        </h4>
        <p style={{color: '#aaa', margin: '4px 0 0', fontSize: '0.95rem'}}>
          {place.description || 'No description'}
        </p>
      </div>

      <div style={{display: 'flex', gap: '12px', flexShrink: 0}}>
        <button
          onMouseEnter={() => setHoveredButton('approve')}
          onMouseLeave={() => setHoveredButton(null)}
          onClick={e => {
            e.stopPropagation();
            onApprove();
          }}
          style={approveStyle}>
          Approve
        </button>
        <button
          onMouseEnter={() => setHoveredButton('decline')}
          onMouseLeave={() => setHoveredButton(null)}
          onClick={e => {
            e.stopPropagation();
            onDecline();
          }}
          style={declineStyle}>
          Decline
        </button>
      </div>
    </div>
  );
};
